/* eslint no-useless-escape: 0 */
// regex from http://stackoverflow.com/questions/46155/validate-email-address-in-javascript
const EMAIL_REGEX = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-?\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;

const validateEmail = email => email
        && email.length < 255
        && EMAIL_REGEX.test(email);

const validateEmailInputText = emailAddressText => !!(
    emailAddressText
    && emailAddressText
        .split(',')
        .every(email => validateEmail(email.trim()))
);

export { validateEmail, validateEmailInputText };
